import { Type } from '@angular/core';

export class DocumentItem {
  constructor(public component: Type<any>, public key: string, public data: any) { }
}
